<template>
<div class="abacus">
	<div class="abacus__body">
		<div class="abacus__wrap">
			<axis
				v-for="(item, i) in axisQnt"
				:extVal="breakSum[i]"
				ref="item" :key="i"
				:show-numbers="showNumbers"
				:can-change="canChange"
				:animate="animate"
				@bonesChanged="axisSum" @clickBone="clickBone">
			</axis>
		</div>		
	</div>
  <h3 class="abacus__sum" v-if="showSum">Сумма: <span>{{ sum }}</span></h3>
	<div v-if="showClear">
		<button class="uk-button uk-button-primary" @click="nullAbacus">Сброс</button>
	</div>
</div>
</template>

<script>
  import axis from './axis'
  import { mix } from "../mixin";
  export default {
    name: "game",
    mixins: [
      mix
    ],
    components: {
      axis
    },
    data() {
      return {
        sum: 0,
        value: 0,
        sumArray: [],
      }
    },
	  props: {
      showClear: '',
		  axisQnt: '',
		  canChange: '',
		  showNumbers: '',
		  showSum: '',
		  abacusValue: '',
		  animate: {
        default:true,
			  value: ''
		  }
	  },
    watch: {
      'sum': function () {
      },
      'abacusValue': function () {
	      this.value = this.abacusValue;
      }
    },
    computed: {
      breakSum(){
        //console.log('break Sum');
        const splitNumber = n => [ ...n.toString() ];
        let val = this.value;

        let numArr = splitNumber(val);
        let qnt = this.axisQnt;
        if(val === ''){
          return [];
        }
        if(qnt > numArr.length){
          let q = qnt - numArr.length;
          for(let i = 1; i < q+1; i++){
            numArr.unshift('0');
          }
        }
        //this.$set(this, 'sumArray', numArr);
        //bus.$emit('abacusValueUpdated');
        //this.sumArray = numArr;
        return numArr;
      },
    },
    methods: {
      nullAbacus(){
        this.value = 0;
      },
      clickBone(){
        this.value = '';
        this.sumArray = [];
      },
      axisSum() {
        //console.log('Axis sum');
        let obj = this.$refs.item;
        let count = obj.length;
        let pow = count - 1;
        let sum = 0;

        for (let i = 0; i < count; i++) {
          let axisSum = obj[i].axisSum;
          sum = sum + axisSum * Math.pow(10, pow);
          pow--;
        }
        this.sum = sum;
        this.$emit('axisSum', sum);
        //console.log(sum);
        /*if(this.value !== sum){
          this.value = sum;
        }*/
      },

    },
    mounted() {

    }
  }
</script>
